import {IServerSideGetRowsRequest} from 'ag-grid-community'
import {post} from '@/services/infrastructure/api.service'
import {DocumentMeta} from '@/types/transaction/DocumentMeta'
import {toQueryRequest} from '@/query/AgGridAdapter'

export const findDocumentMeta = async (request: IServerSideGetRowsRequest): Promise<DocumentMeta[]> => {
    return await post('/documents/:get-rows', toQueryRequest(request))
}